module.exports = {"341372001":"金海街道","341372402":"鞋城行政区域"}


//////////////////
// WEBPACK FOOTER
// ./src/town/341372.json
// module id = 1243
// module chunks = 0